<template>
<div 
    v-if="camp"
    class="mt-3 btn-event-card"
>
    <div class="h-auto event-card-short mb-0">
        <div class="row">
            <div 
                class="col-4 image-container"
                :style="backgroundImage"
            >
                <span 
                    v-if="camp.sports && camp.sports.length > 0"
                    class="rounded-0 sport-tag"
                    style="border-radius:5px !important;margin:0 5px;bottom:6px;background-color:rgba(255, 255, 255, 0.75);"
                >
                    {{camp.sport_tag_string}}
                </span>
            </div>
            <div class="justify-content-start col-8 info-container pr-0">
                <div 
                    v-if="companyName"
                    class="summer-camp-company-container"
                >
                    <p class="company-name" v-text="companyName"></p>
                    <p class="event-title font-16 text-dark" v-text="camp.name"></p>
                </div>
                <div>
                    <div
                        v-if="camp.fullAddress"
                        class="event-address-container"
                    >
                        <img
                            src="/images/map/map_marker.svg"
                            alt=""
                        />
                        <p
                            class="font-14 fw-500 text-dark event-address"
                            v-text="camp.fullAddress"></p>
                    </div>
                    <div class="event-dates-container">
                        <img
                            src="/images/icons/calendar_icon_orango.svg"
                            alt=""
                        />
                        <p class="event-date">
                            <span v-if="isTheSameMonth">
                                Dal {{dateFormatter(camp.start_date, 'D')}}
                                al {{dateFormatter(camp.end_date, 'D')}}
                                <span class="text-capitalize">{{dateFormatter(camp.start_date, 'MMMM')}}</span>
                            </span>
                            <span v-else>
                                Dal {{dateFormatter(camp.start_date, 'D')}}
                                <span class="text-capitalize">{{dateFormatter(camp.start_date, 'MMMM')}}</span>
                                al {{dateFormatter(camp.end_date, 'D')}}
                                <span class="text-capitalize">{{dateFormatter(camp.end_date, 'MMMM')}}</span>
                            </span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-4 image-button-container">
            <div class="col-6 pl-0 d-flex align-items-center justify-content-end">
                <img
                    v-if="camp.disabilities && camp.disabilities.length"
                    src="/images/icons/disabilities.svg"
                    class="img-fluid float-right"
                />
            </div>
            <div class="col-6 pr-0">
                <button 
                    type="button"
                    @click="onShowDetail"
                    class="btn btn-block fw-600 float-right" :class="[buttonClass]"
                >
                    {{buttonLabelText}}
                </button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
    export default {
        name: 'CompanySummerCampCard',
        props: {
            camp: {
                type: Object,
                required: true
            },
            company: Object,
            isDetail: {
                type: Boolean,
                required: false
            },
            insideMap: {
                type: Boolean,
                required: false
            },
            buttonLabelText: {
                type: String,
                default: 'Scopri'
            },
            buttonClass: {
                type: String,
                default: 'btn-primary text-uppercase'
            }
        },
        data() {
            return {
                tempTags: [
                    {icon: 'fa-map-marker-alt', text: 'A 10 minuti da te', color: 'orangogo'},
                    {icon: 'fa-tag', text: '-30% sconto', color: 'primary'}
                ]
            }
        },
        computed: {
            isTheSameMonth() {
                let {start_date,end_date} = this.camp

                if (!_.isEmpty(start_date)) {
                    let startDate = start_date.split('-')
                    let endDate = end_date.split('-')
                    return startDate[1] == endDate[1]
                }
                return false
            },
            fullAddress() {
                var address = '';

                if (this.camp.municipality)
                    address = address + ' ' + this.camp.municipality;

                if (this.camp.province)
                    address = address + ' ' + this.camp.province;

                if (this.camp.route)
                    address = address + ',' + this.camp.route;

                if (this.camp.house_number)
                    address = address + ' ' + this.camp.house_number

                if (this.camp.zip)
                    address = address + ',' + this.camp.zip;

                if (this.camp.state)
                    address = address + ',' + this.camp.state;

                return address
            },
            companyName() {
                if (this.company) {
                    return this.company.public_name || this.company.name
                }
                return null
            },
            backgroundImage() {
                if (this.camp.summer_camp_cover_image) {
                    return {
                        'background-image': `url(${this.camp.summer_camp_cover_image})`
                    }
                }
            }
        },
        methods: {
            dateFormatter(date, format = 'DD/MM/YYYY') {
                return moment(date).format(format);
            },
            loadFilteredCourses(camps) {
                this.camp = camps
            },
            onShowDetail() {
                location.href = route('summer-camps.show', this.camp.slug)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/company/CompanySummerCampCard.vue